"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SamlSettingsModel", {
    enumerable: true,
    get: function() {
        return SamlSettingsModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const SamlSettingsModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    custom_attribute: _zod.z.string().optional(),
    deleted: _zod.z.boolean().optional(),
    deleted_at: _zod.z.date().optional(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    label: _zod.z.string().optional(),
    settings: _zod.z.object({
        debug: _zod.z.boolean(),
        idp: _zod.z.object({}),
        sp: _zod.z.object({
            privateKey: _zod.z.string().optional(),
            x509cert: _zod.z.string().optional(),
            x509certNew: _zod.z.string().optional()
        }).passthrough(),
        strict: _zod.z.boolean()
    }).passthrough(),
    state: _zod.z.enum([
        "disabled",
        "enabled"
    ]),
    use_custom_attribute: _zod.z.boolean().optional(),
    rotation: _zod.z.object({
        status: _zod.z.enum([
            "started",
            "rotating"
        ]),
        started_at: _zod.z.date().optional(),
        rotated_at: _zod.z.date().optional(),
        new_key: _zod.z.string().optional(),
        old_key: _zod.z.string().optional(),
        old_x509_cert: _zod.z.string().optional()
    }).optional()
});
